import React, { useEffect, useState } from "react";
import Icon from "../Icon";

interface CollapsibleContentProps {
  title: string;
  expanded?: boolean;
  className?: string;
  expandedClassName?: string;
  collapsible?: boolean;
  html?: string;
  addionalContent?: string;
  expandOnHeaderClick?: boolean;
}

const CollapsibleContent: React.FC<CollapsibleContentProps> = ({
  title,
  expanded = false,
  children,
  html,
  addionalContent,
  className,
  expandedClassName,
  expandOnHeaderClick,
}) => {
  const [isExpanded, setExpanded] = useState(expanded);

  useEffect(() => {
    setExpanded(expanded);
  }, [expanded]);

  return (
    <section className={className ? className : ""}>
      <header
        className={`p-4 border bg-light border-accent cursor-pointer ${
          isExpanded ? "rounded-t-lg" : "rounded-lg"
        } sm:text-lg font-medium text-text flex items-center justify-between`}
        onClick={
          expandOnHeaderClick ? () => setExpanded((prev) => !prev) : undefined
        }
      >
        {title}
        <button
          className="leading-none text-text focus:outline-none"
          onClick={
            expandOnHeaderClick ? undefined : () => setExpanded((prev) => !prev)
          }
        >
          <Icon className="text-xl">
            {isExpanded ? "keyboard_arrow_up" : "keyboard_arrow_down"}
          </Icon>
        </button>
      </header>
      {isExpanded &&
        (html ? (
          <article
            className={`rounded-b-lg border-accent border border-t-0 p-2 sm:p-4 whitespace-pre-line text-text ${expandedClassName}`}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: html.replace(/<ul/g, '<ul class="list-disc pl-8"'),
              }}
            />
            {addionalContent && <div>{addionalContent}</div>}
          </article>
        ) : (
          <article className="p-2 whitespace-pre-line border border-t-0 rounded-b-lg border-accent sm:p-4 text-text">
            {children}
          </article>
        ))}
    </section>
  );
};

export default CollapsibleContent;
